import { FONT_FAMILIES } from 'schema/src/kinds/poll/theme';

export type ThemeFontFamilies = (typeof FONT_FAMILIES)[number];

export const POLL_THEME_FONTS: Record<
  Exclude<ThemeFontFamilies, 'dsHeading' | 'dsText'>,
  'FactorA' | 'NeueHaasUnica' | 'PfHighway' | 'RobotoFlex' | 'Montserrat' | 'Graphik'
> = {
  ['Factor A']: 'FactorA',
  ['haas']: 'NeueHaasUnica',
  ['pfhighway']: 'PfHighway',
  ['Roboto Flex']: 'RobotoFlex',
  ['Montserrat']: 'Montserrat',
  ['Graphik']: 'Graphik',
} as const;

export const FALLBACK_TUI_FONTS = {
  heading:
    'var(--tui-font-heading, dsHeading, "dsHeading Fallback", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif)',
  text: 'var(--tui-font-text, dsText, "dsText Fallback", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif)',
} as const;

export const ROOT_TDS_ATTRIBUTE = 'data-tds-theme';
export const ROOT_TUI_ATTRIBUTE = 'data-tui-theme';

export const ROOT_TUI_DESKTOP_TYPOGRAPHY_SELECTOR_DESKTOP =
  ':root,[data-tui-typography="desktop"][data-tui-typography="desktop"]';
export const ROOT_TUI_DESKTOP_TYPOGRAPHY_SELECTOR_ANDROID =
  ':root,[data-tui-typography="android"][data-tui-typography="android"]';

export const ROOT_TUI_DESKTOP_TYPOGRAPHY_SELECTOR_IOS = ':root,[data-tui-typography="ios"][data-tui-typography="ios"]';
export const ROOT_TUI_DARK_THEME_SELECTOR = `:root[${ROOT_TUI_ATTRIBUTE}="dark"][${ROOT_TUI_ATTRIBUTE}="dark"][${ROOT_TUI_ATTRIBUTE}="dark"]`;
export const ROOT_TUI_LIGHT_THEME_SELECTOR = `:root[${ROOT_TUI_ATTRIBUTE}="light"][${ROOT_TUI_ATTRIBUTE}="light"][${ROOT_TUI_ATTRIBUTE}="light"]`;

export const ROOT_TDS_LIGHT_THEME_SELECTOR = `:root[${ROOT_TDS_ATTRIBUTE}="light"][${ROOT_TDS_ATTRIBUTE}="light"][${ROOT_TDS_ATTRIBUTE}="light"]`;
export const ROOT_TDS_DARK_THEME_SELECTOR = `:root[${ROOT_TDS_ATTRIBUTE}="dark"][${ROOT_TDS_ATTRIBUTE}="dark"][${ROOT_TDS_ATTRIBUTE}="dark"]`;
